import { Stack, Typography } from "@mui/material";
import { calculatePercentage } from "../../utils";

import type { FC } from "react";

export const AnalyticsOverviewPercentage: FC<{
  data: {
    count: number;
    total: number;
  };
}> = ({ data }) => {
  const percentage = calculatePercentage(data.count, data.total);

  return (
    <Stack direction="row" alignItems="baseline" spacing={1}>
      <Typography variant="h5">{`${percentage}%`}</Typography>
      <Typography
        variant="body2"
        color="textSecondary"
      >{`( ${data.count}/${data.total} )`}</Typography>
    </Stack>
  );
};
